/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

export default stubFalse;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/stubFalse.js
// module id = 485
// module chunks = 30 31 32 33 34